import GoogleMapReact from 'google-map-react';
import { Shadow } from '@vfit/shared/atoms';
import { useDeviceType } from '@vfit/shared/hooks';
import { LoggerInstance } from '@vfit/shared/data-access';

import * as O from './consumerOfferMap.style';
import { I_ConsumerOfferMap } from './consumerOfferMap.models';
import { MAP_CONFIG, MAP_OPTIONS } from './consumerOfferMap.utils';

const ConsumerOfferMap = ({ coords, isLoadingCoords = false, embedded = false }: I_ConsumerOfferMap) => {
  const { isDesktop, isTablet } = useDeviceType();

  const myLocationSize = isDesktop
    ? { height: 77.14, width: 60.68 }
    : { height: 56.02, width: 46.56 };
  const mapHeight = embedded
    ? 140
    : isDesktop
      ? 320
      : isTablet
        ? 200
        : 160;

  const renderMarkers = (
    map: google.maps.Map,
    maps: typeof google.maps,
    lat: number,
    lng: number,
    icon: google.maps.Icon | string,
  ) => {
    const marker = new maps.Marker({
      position: { lat, lng },
      icon,
      map,
      zIndex: 60,
    });
    LoggerInstance.debug('ConsumerOfferMap', marker);
  };

  return (
    <O.OfferMapColumn embedded={embedded}>
      <O.OfferMapContainer embedded={embedded}>
        <O.ManageMapHeight embedded={embedded}>
          {isLoadingCoords && (
            <O.MapLoadingOverlay>
              <Shadow height={mapHeight} width="100%" />
            </O.MapLoadingOverlay>
          )}
          {!isLoadingCoords && (
            <GoogleMapReact
              bootstrapURLKeys={MAP_CONFIG}
              zoom={isDesktop ? 18 : 16}
              options={MAP_OPTIONS}
              draggable={false}
              center={coords}
              yesIWantToUseGoogleMapApiInternals
              onGoogleApiLoaded={({ map, maps }) => {
                renderMarkers(map, maps, coords?.lat, coords?.lng, {
                  scaledSize: new google.maps.Size(myLocationSize.height, myLocationSize.width),
                } as google.maps.Icon);
              }}
            />
          )}
        </O.ManageMapHeight>
      </O.OfferMapContainer>
    </O.OfferMapColumn>
  );
};

export default ConsumerOfferMap;
